import { ShieldCheck, Award, Clock } from 'lucide-react';

export default function About() {
  return (
    <section id="about" className="section-padding bg-white relative overflow-hidden border-b border-gray-100">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-20 bg-gradient-to-b from-primary to-transparent"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <div className="inline-block px-3 py-1 bg-white text-primary font-bold text-sm uppercase tracking-wider mb-6 border-b-2 border-primary">
            O Nama
          </div>
          
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-extrabold text-text mb-6 leading-tight">
            Stručnost, Preciznost i <br className="hidden sm:block"/>
            <span className="text-primary">Više od 20+ godina</span> iskustva
          </h2>
          <p className="text-gray-800 text-lg sm:text-xl mb-6 leading-relaxed font-medium">
            Budimlija Elektro pruža profesionalne elektro usluge sa specijalnim fokusom na 
            <strong className="text-primary"> semiranje i izradu elektro ormara</strong>, instalacije jake i slabe struje i sve vrste elektro radova.
          </p>
          <p className="text-gray-700 text-base sm:text-lg mb-8 leading-relaxed">
            Naš rad odlikuju preciznost, sigurnost i poštovanje visokih industrijskih standarda. 
            Bilo da je u pitanju domaćinstvo, poslovni objekat ili industrijski sistem – garantujemo profesionalnu i pouzdanu uslugu.
          </p>
          
          <div className="p-6 bg-white text-text rounded shadow-lg border-l-8 border-primary relative overflow-hidden group text-left max-w-2xl mx-auto">
            <div className="absolute top-0 right-0 w-16 h-16 bg-red-50 rounded-bl-full -mr-8 -mt-8 z-0 group-hover:bg-red-100 transition-colors"></div>
            <p className="italic font-bold text-base sm:text-lg relative z-10 text-center">
              "Naš cilj je da obezbedimo sigurna i dugotrajna elektro rešenja koja pokreću vaš posao i dom."
            </p>
          </div>
        </div>

        {/* Trust Cards */}
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6">
          <div className="bg-white p-6 sm:p-8 rounded shadow-[0_4px_20px_rgba(0,0,0,0.08)] border-t-4 border-primary hover:-translate-y-1 transition-transform duration-300 group">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-red-50 rounded flex items-center justify-center mb-4 group-hover:bg-primary transition-colors duration-300">
              <Award className="text-primary w-6 h-6 sm:w-8 sm:h-8 group-hover:text-white transition-colors duration-300" strokeWidth={2} />
            </div>
            <h3 className="text-xl font-bold text-text mb-3 group-hover:text-primary transition-colors">Specijalizacija: Semiranje</h3>
            <p className="text-gray-700 text-base leading-relaxed">
              Glavna delatnost firme – precizna izrada, šemiranje i povezivanje elektro ormara za industriju i stambene objekte.
            </p>
          </div>

          <div className="bg-white p-6 sm:p-8 rounded shadow-[0_4px_20px_rgba(0,0,0,0.08)] border-t-4 border-primary hover:-translate-y-1 transition-transform duration-300 group">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-red-50 rounded flex items-center justify-center mb-4 group-hover:bg-primary transition-colors duration-300">
              <ShieldCheck className="text-primary w-6 h-6 sm:w-8 sm:h-8 group-hover:text-white transition-colors duration-300" strokeWidth={2} />
            </div>
            <h3 className="text-xl font-bold text-text mb-3 group-hover:text-primary transition-colors">Stručno i Sigurno</h3>
            <p className="text-gray-700 text-base leading-relaxed">
              Licencirani i obučeni električari sa višegodišnjim iskustvom. Poštujemo sve bezbednosne standarde i propise.
            </p>
          </div>

          <div className="bg-white p-6 sm:p-8 rounded shadow-[0_4px_20px_rgba(0,0,0,0.08)] border-t-4 border-primary hover:-translate-y-1 transition-transform duration-300 group sm:col-span-2 md:col-span-1">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-red-50 rounded flex items-center justify-center mb-4 group-hover:bg-primary transition-colors duration-300">
              <Clock className="text-primary w-6 h-6 sm:w-8 sm:h-8 group-hover:text-white transition-colors duration-300" strokeWidth={2} />
            </div>
            <h3 className="text-xl font-bold text-text mb-3 group-hover:text-primary transition-colors">Kvalitet i Garancija</h3>
            <p className="text-gray-700 text-base leading-relaxed">
              Garantujemo profesionalno izvedene radove, poštovanje rokova i dugotrajna rešenja za vaše instalacije.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
